import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/home/ncadeddu/dev/projects/Web Component/ListNewsWC/node_modules/css-loader/dist/runtime/api.js'
import '/home/ncadeddu/dev/projects/Web Component/ListNewsWC/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/home/ncadeddu/dev/projects/Web Component/ListNewsWC/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import newsOp from '~root/src/App.vue?shadow'
window.customElements.define('news-op', wrap(Vue, newsOp))